const domain = "https://zepcruit.ai";
// const domain = 'https://nqmbmslz-8000.inc1.devtunnels.ms'; // test domains
// const testDomain = "https://zepcruit.ai/tcandidate-zepcrui/api/v1";
const testDomain = process.env.REACT_APP_API_URL;

// ----Fake APIs
export const FAKE_API = `https://jsonplaceholder.typicode.com/todos/1`;
export const USER_PROFILE_UPDATE = `${testDomain}/user/update-profile`;

export const GET_JOB_SCREENING_QUESTIONS = `${testDomain}/jobs/screening-questions`;


// ----Fake APIs

// ----JOB related Apis
// export const JOBS_FINDER = `${domain}/api/users/search-jobs`;
export const JOBS_FINDER = `${testDomain}/jobs/search-jobs`;
// export const APPLY_JOB = `${domain}/api/users/apply-jobs`;
export const APPLY_JOB = `${testDomain}/jobs/apply-job`;
// export const RECOMMENDED_JOBS = `${domain}/api/users/homepage`;
// export const RECOMMENDED_JOBS = `${domain}/api/users/homepage`;
// export const DASHBOARD_DATA_API = `${domain}/api/users/homepage`;
export const DASHBOARD_ACTION_DISC = `${testDomain}/user/homepage`;
export const DASHBOARD_JOBS = `${testDomain}/user/recommended-jobs?page=1&limit=10`;
// export const APPLIED_JOBS_FINDER = `${testDomain}/api/users/fetch-applied-jobs`;
export const APPLIED_JOBS_FINDER = `${testDomain}/jobs/applied-jobs`;
// export const JOBS_BY_JOBID = `${testDomain}/api/users/getjob`;
export const JOBS_BY_JOBID = `${testDomain}/jobs/get-job`;

// registration related Apis
export const USER_REGISTER = `${domain}/api/auth/register`;
export const USER_EMAIL_REGISTER = `${testDomain}/auth/send-otp`;
export const REGISTRATION_OTP_VERIFY = `${testDomain}/auth/verify-otp`;
// export const USER_REGISTER_OTP_SENDER = `${domain}/api/auth/register`;
export const UPDATE_PROFILE_IMAGE = `${testDomain}/user/profile-picture`;
export const UPDATE_CV = `${testDomain}/user/resume`;
export const CREATE_PROFILE = `${testDomain}/user/create-profile`;

// login related apis
export const USER_LOGIN = `${testDomain}/auth/login`;
export const USER_LOGOUT = `${testDomain}/auth/logout`;
// export const USER_AUTH_VALIDATION = `${domain}/api/users/verify-token`;

// profile related apis
// export const USER_PROFILE_GETTER = `${testDomain}/api/users/get-profile`;
export const USER_PROFILE_GETTER = `${testDomain}/user/get-profile`;
// export const TOGGLE_OPEN_TO_WORK = `${domain}/api/users/availability`;
export const TOGGLE_OPEN_TO_WORK = `${testDomain}/user/open-to-work`;

// constents data related apis
export const INDUSTRIES_API = `${testDomain}/user/get-industries`;

// forgot Password related
export const REQUEST_FORGOT_PASSWORD = `${testDomain}/auth/forgot-password`;
export const VERIFY_OTP = `${testDomain}/auth/verify-forgot-password-otp`;
export const UPDATE_FORGOT_PASSWORD = `${testDomain}/auth/reset-password`;

// mobile number verification
export const SEND_MOBILE_OTP = `${testDomain}/auth/mobile-otp`;
export const VERIFY_MOBILE_OTP = `${testDomain}/auth/verify-mobile-otp`;

// Interview related Apis
export const VERIFY_INTERVIEW = `${testDomain}/interview/verify-interview`;
export const QUESTION_GETTER = `${testDomain}/interview/get-questions`;
export const PREVIEW_VIDEO_SUBMIT = `${testDomain}/interview/upload-sample-video`;
// export const INTERVIEW_SUBMIT = `${domain}/api/users/dbupdate`;
export const INTERVIEW_SUBMIT = `${testDomain}/interview/submit-interview`;
// export const FORCE_INTERVIEW_SUBMIT = `${domain}/api/users/dbupdate_end`;
export const QUESTION_SUBMIT = `${testDomain}/interview/upload-video`;

// export const UPDATE_FORGOT_PASSWORD = `${domain}----------------------------`;
// export const SEND_OTP_TO_VERIFY_EMAIL = `${domain}/api/auth/sendOTP`;

// export const GOOGLE_AUTH_API = `${domain}/api/auth/google/callback`;
export const GOOGLE_AUTH_API = `${domain}/api/auth/google`;

//disc question fetching
export const DISC_QUESTION = `${testDomain}/user/disc-questions`;

//disc question submission
export const DISC_TEST = `${testDomain}/user/disc-test`;

//JD Generator ans MOCK
// export const JD_GENERATOR = `${domain}/JD/jobDescription`;
// export const MOCK_RESUME_UPLOAD = `${domain}/api/users/mock-resume`;
// export const MOCK_JOB_DESCRIPTION = `${domain}/api/users/add-mock-data`;
// export const FETCH_MOCKS = `${domain}/api/users/get-mock-data`;
export const FETCH_MOCKS = `${testDomain}/interview/get-mock`;
export const MOCK_ANSWER_SUBMIT = `${testDomain}/interview/add-mock-video`;
export const GENERATE_SHARE_URL = `${testDomain}/interview/share-mock-interview`;
export const REDEEM_CREDIT_URL = `${testDomain}/interview/apply-mock-interview`;
export const GET_MOCK_CREDIT = `${testDomain}/transaction/get-credits`;
export const GET_MOCK_PLAN = `${testDomain}/transaction/get-plans`;
// export const NEW_MOCK_CREATE = `${domain}/api/users/add-mock-resume`;
export const NEW_MOCK_CREATE = `${testDomain}/interview/add-mock`;
export const FETCH_MOCK_DETAIL = `${testDomain}/interview/get-mock`;

// payments
// export const VERIFY_USERS_PLAN = `${domain}/api/transaction/verify-transaction`;
export const VERIFY_COUPON_CODE = `${testDomain}/transaction/verify-coupon`; //DONE
// export const CREATE_PAYMENT_REQUEST = `${domain}/api/payment/create-order`;
export const CREATE_PAYMENT_REQUEST = `${testDomain}/transaction/create-order`; //DONE
// export const CREATE_PAYMENT_REQUEST_WITH_FULL_DISCOUNT = `${domain}/api/payment/full-discount`;
// export const VERIFY_PAYMENT_ORDER = `${domain}/api/payment/verify-payment`;
export const VERIFY_PAYMENT_ORDER = `${testDomain}/transaction/verify-payment`; //DONE
// export const MAKE_TRANSACTION = `${domain}/api/transaction/makeTransaction`;

// Signups for linkedin users
export const LINKEDIN_SIGNUP = `${testDomain}/user/linkedin-resume-upload`;
export const LINKEDIN_SIGNUP_VERIFICATION = `${testDomain}/auth/password-upload`;

export const REPORT_BUG = `${testDomain}/reportBug`;
